module.exports = __webpack_public_path__ + "tab_wode_default.png?be4c02ee80619ca92b6a15cb6e95c2a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_wode_default.png
// module id = 138
// module chunks = 0